"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var VideoCameraOffFillYes = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.ImpureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_VideoCameraOffFillYes_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 16,
    height: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.668 12.5h4.16c.592 0 .888 0 1.115-.116a1.06 1.06 0 0 0 .462-.464c.115-.227.115-.525.115-1.12V7.951c0-.506 0-.93-.01-1.292L5.668 12.5ZM10.021 3.81l-8.426 8.427A2.776 2.776 0 0 1 .302 10.98C0 10.386 0 9.607 0 8.049v-2.85c0-.594 0-.892.115-1.119.102-.2.263-.362.462-.464C.804 3.5 1.1 3.5 1.692 3.5H7.09c1.55 0 2.326 0 2.919.303l.013.007ZM14.501 11.888l-1.48-1.238c-.24-.202-.361-.303-.458-.418a1.722 1.722 0 0 1-.377-.809c-.026-.148-.026-.306-.026-.621V7.198c0-.315 0-.473.026-.621.053-.298.183-.577.377-.809.097-.115.217-.216.459-.418L14.5 4.112c.363-.304.544-.455.69-.492a.652.652 0 0 1 .743.35c.066.136.066.373.066.847v6.366c0 .474 0 .711-.066.847a.652.652 0 0 1-.743.35c-.146-.037-.327-.188-.69-.492Z",
    fill: "#000001"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_VideoCameraOffFillYes_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#131619",
    d: "M0 0h16v16H0z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon_VideoCameraOffFillYes_".concat(randomId, "_b"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.844.156a.533.533 0 0 1 0 .754L.91 15.844a.533.533 0 1 1-.754-.755L15.09.156a.533.533 0 0 1 .755 0Z",
    fill: "#ED4D6A"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_VideoCameraOffFillYes_".concat(randomId, "_b)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F21F31",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = VideoCameraOffFillYes;
exports["default"] = _default;